import { casinoData } from "../data/data";

const CasinoComparison = () => {
  const getRatingColor = (rating) => {
    return parseFloat(rating) >= 4 ? '#029227' : '#FFB103';
  };

  const renderStars = (rating) => {
    const ratingValue = parseFloat(rating);
    const stars = [];

    for (let i = 1; i <= 5; i++) {
      let style = {};

      if (i <= Math.floor(ratingValue)) {
        style = { '--e-rating-icon-marked-width': '100%' };
      } else if (i === Math.ceil(ratingValue) && ratingValue % 1 !== 0) {
        const percentage = (ratingValue % 1) * 100;
        style = { '--e-rating-icon-marked-width': `${percentage}%` };
      } else {
        style = { '--e-rating-icon-marked-width': '0%' };
      }

      stars.push(
        <div key={i} className="e-icon">
          <div className="e-icon-wrapper e-icon-marked" style={style}>
            <svg aria-hidden="true" className="e-font-icon-svg e-eicon-star" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
              <path d="M450 75L338 312 88 350C46 354 25 417 58 450L238 633 196 896C188 942 238 975 275 954L500 837 725 954C767 975 813 942 804 896L763 633 942 450C975 417 954 358 913 350L663 312 550 75C529 33 471 33 450 75Z"></path>
            </svg>
          </div>
          <div className="e-icon-wrapper e-icon-unmarked">
            <svg aria-hidden="true" className="e-font-icon-svg e-eicon-star" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
              <path d="M450 75L338 312 88 350C46 354 25 417 58 450L238 633 196 896C188 942 238 975 275 954L500 837 725 954C767 975 813 942 804 896L763 633 942 450C975 417 954 358 913 350L663 312 550 75C529 33 471 33 450 75Z"></path>
            </svg>
          </div>
        </div>
      );
    }

    return stars;
  };

  return (
    <div className="elementor-element elementor-element-b208738 e-flex e-con-boxed e-con e-parent" data-id="b208738" data-element_type="container" id="compare">
      <div className="e-con-inner">

        {/* Título Principal */}
        <div className="elementor-element elementor-element-6b33f17 elementor-widget elementor-widget-heading" data-id="6b33f17" data-element_type="widget" data-widget_type="heading.default">
          <div className="elementor-widget-container">
            <h2 className="elementor-heading-title elementor-size-default">Compare os Melhores Casinos Online Regulado de Portugal</h2>
          </div>
        </div>

        {/* Descrição */}
        <div className="elementor-element elementor-element-e0a3ce0 elementor-widget elementor-widget-text-editor" data-id="e0a3ce0" data-element_type="widget" data-widget_type="text-editor.default">
          <div className="elementor-widget-container">
            No Casinoplusportugal, fornecemos comparações detalhadas dos melhores casinos online regulamentados em Portugal. O nosso objetivo é ajudá-lo a tomar decisões informadas ao escolher onde jogar, garantindo uma experiência de jogo segura, justa e agradável. Abaixo, encontrará uma comparação lado a lado dos principais casinos licenciados em Portugal, com base em vários critérios importantes.
          </div>
        </div>

        {/* Cabeçalho da Tabela (Desktop) */}
        <div className="elementor-element elementor-element-f68f2c6 e-con-full elementor-hidden-mobile e-flex e-con e-child" data-id="f68f2c6" data-element_type="container" data-settings='{"background_background":"classic"}'>
          <div className="elementor-element elementor-element-1bbbd47 e-con-full e-flex e-con e-child" data-id="1bbbd47" data-element_type="container">
            <div className="elementor-element elementor-element-282aa78 elementor-widget elementor-widget-heading" data-id="282aa78" data-element_type="widget" data-widget_type="heading.default">
              <div className="elementor-widget-container">
                <span className="elementor-heading-title elementor-size-default">Marca</span>
              </div>
            </div>
          </div>
          <div className="elementor-element elementor-element-2333a82 e-con-full e-flex e-con e-child" data-id="2333a82" data-element_type="container">
            <div className="elementor-element elementor-element-f6bd1ff elementor-widget elementor-widget-heading" data-id="f6bd1ff" data-element_type="widget" data-widget_type="heading.default">
              <div className="elementor-widget-container">
                <span className="elementor-heading-title elementor-size-default">Funcionalidades</span>
              </div>
            </div>
          </div>
          <div className="elementor-element elementor-element-4514e12 e-con-full e-flex e-con e-child" data-id="4514e12" data-element_type="container">
            <div className="elementor-element elementor-element-39d3151 elementor-widget elementor-widget-heading" data-id="39d3151" data-element_type="widget" data-widget_type="heading.default">
              <div className="elementor-widget-container">
                <span className="elementor-heading-title elementor-size-default">Classificações</span>
              </div>
            </div>
          </div>
          <div className="elementor-element elementor-element-0ecdb0e e-con-full e-flex e-con e-child" data-id="0ecdb0e" data-element_type="container">
            <div className="elementor-element elementor-element-dd4c9fd elementor-widget elementor-widget-heading" data-id="dd4c9fd" data-element_type="widget" data-widget_type="heading.default">
              <div className="elementor-widget-container">
                <span className="elementor-heading-title elementor-size-default">Visitar</span>
              </div>
            </div>
          </div>
        </div>

        {/* Mapeamento dos Itens (Linhas da Tabela) */}
        {casinoData.map((item, index) => (
          <div key={index} className="elementor-element elementor-element-07de2a5 e-con-full elementor-hidden-mobile e-flex e-con e-child" data-id="07de2a5" data-element_type="container" data-settings='{"background_background":"classic"}'>

            {/* Logo */}
            <div className="elementor-element elementor-element-c7f75bf e-con-full e-flex e-con e-child" data-id="c7f75bf" data-element_type="container">
              <div className="elementor-element elementor-element-7d2b3d7 elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="7d2b3d7" data-element_type="widget" data-widget_type="image.default">
                <div className="elementor-widget-container">
                  <a href={item.affiliateLink} target="_blank" rel="noopener noreferrer">
                    <img decoding="async" width="512" height="512" src={item.logoUrl} className="attachment-large size-large wp-image-3313" alt={item.name} />
                  </a>
                </div>
              </div>
            </div>

            {/* Descrição/Funcionalidades */}
            <div className="elementor-element elementor-element-0eaed16 e-con-full e-flex e-con e-child" data-id="0eaed16" data-element_type="container">
              <div className="elementor-element elementor-element-c831bd7 elementor-widget elementor-widget-text-editor" data-id="c831bd7" data-element_type="widget" data-widget_type="text-editor.default">
                <div className="elementor-widget-container">
                  {item.description}
                </div>
              </div>
            </div>

            {/* Classificação / Rating */}
            <div className="elementor-element elementor-element-304cc20 e-con-full e-flex e-con e-child" data-id="304cc20" data-element_type="container">
              <div className="elementor-element elementor-element-f8b04e6 e-con-full e-flex e-con e-child" data-id="f8b04e6" data-element_type="container">
                <div className="elementor-element elementor-element-9d51a6a e-con-full e-flex e-con e-child" data-id="9d51a6a" data-element_type="container"
                  style={{ backgroundColor: getRatingColor(item.ratingValue) }}
                  data-settings='{"background_background":"classic"}'>
                  <div className="elementor-element elementor-element-fca2ed3 elementor-widget elementor-widget-heading" data-id="fca2ed3" data-element_type="widget" data-widget_type="heading.default">
                    <div className="elementor-widget-container">
                      <span className="elementor-heading-title elementor-size-default">
                        {item.ratingValue}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="elementor-element elementor-element-23f0c88 e-con-full e-flex e-con e-child" data-id="23f0c88" data-element_type="container">
                  <div className="elementor-element elementor-element-c8ac522 elementor-widget elementor-widget-heading" data-id="c8ac522" data-element_type="widget" data-widget_type="heading.default">
                    <div className="elementor-widget-container">
                      <span className="elementor-heading-title elementor-size-default">{item.ratingText}</span>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-577e837 elementor-widget elementor-widget-rating" data-id="577e837" data-element_type="widget" data-widget_type="rating.default">
                    <div className="elementor-widget-container">
                      <div className="e-rating" itemType="https://schema.org/Rating" itemScope="" itemProp="reviewRating">
                        <meta itemProp="worstRating" content="0" />
                        <meta itemProp="bestRating" content="5" />
                        <div
                          className="e-rating-wrapper"
                          itemProp="ratingValue"
                          content={item.ratingValue}
                          role="img"
                          aria-label={`Rated ${item.ratingValue} out of 5`}
                        >
                          {renderStars(item.ratingValue)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Botão Visitar */}
            <div className="elementor-element elementor-element-a362d07 e-con-full e-flex e-con e-child" data-id="a362d07" data-element_type="container">
              <div className="elementor-element elementor-element-d3a7984 elementor-align-justify aiospec-click aiobrand-88 elementor-widget elementor-widget-button" data-id="d3a7984" data-element_type="widget" data-widget_type="button.default">
                <div className="elementor-widget-container">
                  <div className="elementor-button-wrapper">
                    <a className="elementor-button elementor-button-link elementor-size-sm" href={item.affiliateLink} target="_blank" rel="noopener noreferrer">
                      <span className="elementor-button-content-wrapper">
                        <span className="elementor-button-text">Visitar o site</span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* T&Cs Absolute */}
            <div className="elementor-element elementor-element-11bfe4c elementor-widget__width-initial elementor-absolute elementor-widget elementor-widget-text-editor" data-id="11bfe4c" data-element_type="widget" data-settings='{"_position":"absolute"}' data-widget_type="text-editor.default">
              <div className="elementor-widget-container">
                {item.terms}
              </div>
            </div>

          </div>
        ))}

      </div>
    </div>
  );
};

export default CasinoComparison;